(function () {
'use strict';

angular
  .module('hyresgastApp')
  .controller('NegotiationTableNegotiatorPropertiesListCtrl', NegotiationTableNegotiatorPropertiesListCtrl);

function NegotiationTableNegotiatorPropertiesListCtrl(
  $location, $routeParams,
  FeatureConfiguration, NegotiationStates, RealEstate,
  Auth
) {
  var vm = this;
  vm.FeatureConfiguration = FeatureConfiguration;
  vm.isHgfUser = Auth.isHgfUser();

  vm.columns = [
    { title: 'Fastighetsbeteckning', column: 'propertyDesignation' },
    { title: 'Kommun', column: 'municipality' },
    { title: 'LM distrikt', column: 'district' },
    { title: 'Lägenheter jag förhandlar', column: 'numNegotiatedApartments', template: 'slot1' }
  ];
  if (vm.FeatureConfiguration.ENABLE_MEETINGS) {
    vm.listColumns.splice(4, 0, { title: 'Nästa möte', column: 'updatedAt' });
  }

  vm.gotoProperty = property => {
    if (Auth.isHgfUser()) {
      $location.search({});
      $location.path('/properties/' + property.id);
    }
  }

  vm.getData = function (params) {
    // eslint-disable-next-line no-undef, no-unused-vars
    return new Promise((resolve, reject) => {
      params = Object.assign({
        partnerId: $routeParams.partnerId,
        'filters[state]': [
          NegotiationStates.IN_PROGRESS,
          NegotiationStates.NEW,
          NegotiationStates.SETTLEMENT,
          NegotiationStates.IN_PREPARATION,
          NegotiationStates.BLOCKED,
          NegotiationStates.PARTIALLY_BLOCKED
        ]
      }, params);
      RealEstate.queryPropertiesInNegotiationsWithMe(params, {})
        .$promise.then(function(data) { resolve(data) });
    });
  }

  vm.getContextInfo = row => ({
    title: `Fastighet ${row.propertyDesignation}`,
    link: '/properties/'+row.id,
  });
}

})();